import React, { useEffect } from 'react'
import './Gallery_detail.css'
import { useDispatch, useSelector } from 'react-redux'
import { getGallery } from '../../../actions/gallery.action'
import { getVideo } from '../../../actions/getVideos.action'
import { useParams } from 'react-router'
import i18next from 'i18next'
import ImageGallery from './imageGallery'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import Preloader from '../../Preloader'
import { API_URI } from '../../../axios'
import PageHeader from '../../page-header/PageHeader'

const Gallery_detail = () => {

    const { id } = useParams()

    const dispatch = useDispatch()
    const language = i18next.language
    const {t} = useTranslation()

    useEffect(() => {
        dispatch(getGallery(id, language))
    }, [language])

    const gallery = useSelector(state => state.gallery)

    const video = useSelector(state => state.video.video_?.data?.videos)

    const { gallery_single } = gallery

    return (
        <>
            <Helmet>
                <title>{`${t("gallery")} - ${t("Ashgabat_International_Airport")}`}</title>
            </Helmet>
            {
                gallery_single ? <div className="gallery-page">
                    <PageHeader
                        title={gallery_single?.title}
                        breadCrumbItems={[
                            { label: t("home"), path: '/' },
                            { label: t("gallery"), path: '/gallery' },
                            { label: gallery_single?.title, path: '#' }
                        ]}
                    />
                    <div className="container py-12">
                        <div className="row justify-content-center">
                            <div className='col-sm-12'>
                            <div className="grid-wrapper grid-lg-3 grid-md-2 grid-sm-1 grid-xs-1">
                                <ImageGallery
                                    theme="gallery-style-2"
                                    data={gallery_single?.images}
                                />
                            </div>
                            </div>
                        </div>
                    </div>
                </div> : <Preloader />
            }
            {/* <div className='container'>
                {video ?
                    video.map(item => (
                        <div key={item.id} className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="100ms">
                            <div className="gallery-page__single">
                                <div>
                                    <video width={'100%'} controls >
                                        <source src={`${API_URI}${item.src}`} type="video/mp4" />
                                    </video>
                                </div>
                            </div>
                        </div>
                    )) : <Preloader/>
                }
            </div> */}
        </>
    )
}

export default Gallery_detail